module.exports = __webpack_public_path__ + "static/media/postgresql-logo-2.2f6096df.png";